/* eslint-disable react/jsx-key */

import { FC } from 'react';
import { useHistory } from 'react-router';
import { Box } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

import NavigationHeader from '../../../../../components/NavigationHeader';
import { CreditCard } from '../../../../../hooks/useCreditCards';
import locales from './locales';
import { getCardActions } from './utils';

interface LockOptionsProps {
  creditCard: CreditCard;
}

const LockOptions: FC<LockOptionsProps> = ({ creditCard }) => {
  const history = useHistory();
  const { creditCardId } = creditCard;

  return (
    <>
      <NavigationHeader backTo={`/cards/${creditCardId}`} />

      <Box marginBottom="space-32">
        <Heading marginBottom="space-16">{locales.title}</Heading>
        <Text>{locales.subtitle}</Text>
      </Box>

      <SunshineCard.Group isBoxed={false}>
        {getCardActions(creditCard, history).map((action) => (
          <SunshineCard onClick={action.onClick}>
            {action.iconName ? (
              <SunshineCard.Slot name="aside">
                <SquircleIcon name={action.iconName} />
              </SunshineCard.Slot>
            ) : null}

            <SunshineCard.Content>
              <SunshineCard.Title>{action.title}</SunshineCard.Title>
              <SunshineCard.Text>{action.description}</SunshineCard.Text>
            </SunshineCard.Content>
          </SunshineCard>
        ))}
      </SunshineCard.Group>
    </>
  );
};

export default LockOptions;
